<template>
  <div>
    <a-table :columns="columns" :data-source="tableInvoices" :loading="tableLoading" :pagination="pagination"
      @change="handleTableChange" class="tableStyle" :scroll="{ x: 1500 }">
      <!-- <template slot="thumb" slot-scope="">
                <img src='../../assets/img/biothrax_bottom_260_x_300_removebg_preview.png'/>
            </template> -->
      <template slot="action" slot-scope="data">
        <a-dropdown>
          <a style="color: #98c14b" class="ant-dropdown-link" @click="(e) => e.preventDefault()">
            <a-icon style="font-size: 25px" type="ellipsis" />
          </a>
          <a-menu slot="overlay">
            <a-menu-item>
              <a @click="showMoreDetails(data)">View Details?</a>
            </a-menu-item>
            <a-menu-item v-if="showPreview(data)">
              <a @click="showInvoicesProducts(data)">Preview?</a>
            </a-menu-item>
            <a-menu-item v-if="showRecordAction(data)">
              <a @click="showPaymentModal(data)">Record Payment?</a>
            </a-menu-item>
            <a-menu-item v-if="showDownload(data)">
              <a @click="downloadInvoice(data)">Download?</a>
            </a-menu-item>
            <a-menu-item v-if="showCancelActions(data)">
              <a @click="showCancelInvoice(data)">Cancel Invoice?</a>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </template>
      <template slot="statusLabel" slot-scope="data">
        <status-component :status="data"></status-component>
      </template>
      <div slot="filterDropdown" slot-scope="{
          setSelectedKeys,
          selectedKeys,
          confirm,
          clearFilters,
          column,
        }" style="padding: 8px">
        <a-input v-ant-ref="(c) => (searchInput = c)" :placeholder="`Search ${column.dataIndex}`"
          :value="selectedKeys[0]" style="width: 188px; margin-bottom: 8px; display: block" @change="
            (e) => setSelectedKeys(e.target.value ? [e.target.value] : [])
          " @pressEnter="
            () => handleSearch(selectedKeys, confirm, column.dataIndex)
          " />
        <a-button type="primary" icon="search" size="small" style="width: 90px; margin-right: 8px"
          @click="() => handleSearch(selectedKeys, confirm, column.dataIndex)">
          Search
        </a-button>
        <a-button size="small" style="width: 90px" @click="() => handleReset(clearFilters)">
          Reset
        </a-button>
      </div>
    </a-table>

    <!-- Receive Purchase Order Model -->
    <a-modal class="modalStyle" :visible="receiveOrderVisible" width="1000px" :footer="null"
      @cancel="handleReceiveOrderCancel">
      <a-spin :spinning="loading">
        <h3 style="
            display: flex;
            justify-content: center;
            font-weight: bolder;
            padding-top: 10px;
            padding-bottom: 30px;
          ">
          Receive Purchase Orders
        </h3>
        <receive-orders-form :data="data" @inventoryRequest="handleAddInventoryTransfer"></receive-orders-form>
      </a-spin>
    </a-modal>
    <!-- Record Payment -->
    <a-modal class="modalStyle" :visible="paymentModalVisible" :footer="null" @cancel="handlePaymentVisibleCancel">
      <a-spin :spinning="loading">
        <h4 style="
            display: flex;
            justify-content: center;
            font-weight: bolder;
            padding-top: 10px;
          ">
          Record Payment
        </h4>
        <div>
          <div>
            <a-form-model ref="paymentForm" :model="paymentModel" :rules="rules">
              <a-row>
                <a-col :span="10" :offset="1">
                  <a-form-model-item label="Issuer" ref="issuer" prop="issuer">
                    <a-select @change="onChangeIssuer" v-model="paymentModel.issuer"
                      placeholder="please select your option">
                      <a-select-option value="0"> VISA </a-select-option>
                      <a-select-option value="1">
                        MTN Mobile Money
                      </a-select-option>
                      <a-select-option value="2">
                        VODAFONE Cash
                      </a-select-option>
                      <a-select-option value="3"> AIRTEL Cash </a-select-option>
                      <a-select-option value="4"> TIGO Cash </a-select-option>
                      <a-select-option value="5"> Bank </a-select-option>
                      <a-select-option value="6"> Master Card </a-select-option>
                      <a-select-option value="7"> Cash </a-select-option>
                      <a-select-option value="8"> Credit </a-select-option>
                    </a-select>
                  </a-form-model-item>
                </a-col>
                <a-col :span="10" :offset="2">
                  <a-form-model-item label="Reference" ref="reference" prop="reference">
                    <a-input class="" :disabled="disableCreditInput" v-model="paymentModel.reference" />
                  </a-form-model-item>
                </a-col>
              </a-row>
              <a-row>
                <a-col :span="10" :offset="1">
                  <a-form-model-item label="Amount" ref="amount" prop="amount">
                    <a-input class="" :disabled="disableCreditInput" v-model="paymentModel.amount" />
                  </a-form-model-item>
                </a-col>
                <a-col :span="10" :offset="1">
                  <a-form-model-item v-if="showPayemntAmount" label="Payment Account" ref="paymentAccount"
                    prop="paymentAccount">
                    <a-input class="" v-model="paymentModel.paymentAccount" />
                  </a-form-model-item>
                </a-col>
              </a-row>
            </a-form-model>
          </div>
          <div style="display: flex; justify-content: center; margin-top: 20px">
            <a-button @click="recordPayment" style="
                background: #418a49;
                height: 59px;
                color: #fff;
                width: 263px;
                border-radius: 5px;
              ">
              Record Payment
            </a-button>
          </div>
        </div>
      </a-spin>
    </a-modal>

    <!-- Show Cancel Payment  -->
    <a-modal class="modalStyle" :visible="cancelModalVisible" :footer="null" @cancel="handleCancelVisibleCancel">
      <a-spin :spinning="loading">
        <p style="font-size: 23px; font-weight: bolder" class="text-center pt-4">
          Cancel Payment for Invoice #{{ data.id }}
        </p>
        <div class="d-flex justify-content-around pt-5">
          <a-button @click="handleCancelVisibleCancel" style="
              background: #ff0000f2;
              color: #fff;
              width: 30%;
              border-radius: 5px;
              border: 1px solid #ff0000f2;
            ">
            No
          </a-button>
          <a-button @click="cancelInvoice" style="
              background: #418a49;
              color: #fff;
              width: 30%;
              border-radius: 5px;
              border: 1px solid #418a49;
            ">
            Yes
          </a-button>
        </div>
      </a-spin>
    </a-modal>
    <invoice ref="invoiceRef"></invoice>
    <download-invoice ref="invoiceDownloadRef"></download-invoice>
  </div>
</template>
<script>

import moment from 'moment';
// import _ from 'lodash';
// import XLSX from "xlsx";
import { NotificationMixins }  from '@/mixins/NotificationMixins'
import { mapActions } from 'vuex';
import ReceiveOrdersForm from '../../orders/modals/ReceiveOrdersForm.vue'
import Invoice from '../../customers/custom/Invoice.vue'
import DownloadInvoice from '../../customers/custom/DownloadInvoice.vue'

const columns = [
{
    title: "Invoice #",
    width: 150,
    dataIndex: 'id',
    key: 'id'
  },
  {
    title: 'Date',
    dataIndex: 'createdAt',
    width: 150,
  },
  
  {
    title: 'Customer Name',
    dataIndex: 'customerName',
    width: 150,
    scopedSlots: {
    filterDropdown: 'filterDropdown',
    filterIcon: 'filterIcon',
    },
    onFilter: (value, record) =>
        record.customerName
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase()),
  },
  {
    title: 'Due Date',
    dataIndex: 'dueDate',
    width: 150,
  },
  {
    title: 'Status',
    dataIndex: 'statusLabel',
    width: 150,
    scopedSlots: { customRender: 'statusLabel' }
  },
  {
    title: 'Payment Method',
    dataIndex: 'paymentMethod',
    width: 150,
  },

  {
    title: 'Amount',
    dataIndex: 'totalOrderValue',
    width: 150,
  },
  {
    title: 'Balance',
    dataIndex: 'balance',
    width: 150,
  },

  {
    title: 'Action',
    dataIndex: 'action',
    width: 150,
    scopedSlots: { customRender: 'action' }
  }
];

const tableData = [
    {
        id:1,
        productId: 1,
        quantity: 23
    },
    {
        id:2,
        productId: 2,
        quantity: 234
    },
    {
        id:3,
        productId: 3,
        quantity: 234
    }
]


    import StatusComponent from '../../shared-components/StatusComponent.vue'
    export default {
        name:"AllInvoices",
        props:['purchaseOrdersData', 'paginateData'],
        mixins: [ NotificationMixins ],
        components: {
            StatusComponent,
            ReceiveOrdersForm,
            Invoice,
            DownloadInvoice
        },
        data(){
            return{
                tableInvoices: this.purchaseOrdersData,
                tableLoading: false,
                receiveOrderVisible: false,
                loading: false,
                columns,
                data: {},
                tableData,
                pagination: {
                    pageSize:20,
                    current: 1,
                    total: 0
                },
                searchText: '',
                searchInput: null,
                searchedColumn: '',
                paymentModalVisible: false,
                cancelModalVisible: false,
                invoiceData: {
                    sellerName: "",
                    sellerAddress:"",
                    sellerCity: "",
                    sellerCountry: "",
                    retailerName: '',
                    retailerAddress: '',
                    retailerCity: '',
                    retailerCountry: '',
                    terms: "",
                    dueDate:'',
                    cowtribeDate:'',
                    invoiceId: '',
                    reference: '',
                    phoneNumber: '',
                    total: '',
                    products: [],
                },
                showPayemntAmount: false,
                paymentModel: {
                    orderType: "",
                    issuer: "",
                    paymentAccount:"",
                    amount: "",
                    reference:""
                },
                allowedPayment: [0,1,2,3,4,5,6],
                rules: {
            
                    issuer: [
                        {
                            required: true,
                            message: "Please select your option",
                            trigger: "change",
                        },
                    ],
                    paymentAccount: [
                        {
                            required: true,
                            message: "Please enter payment amount",
                            trigger: "change",
                        },
                    ],
                    amount: [
                        {
                            required: true,
                            message: "Please enter amount",
                            trigger: "change",
                        },
                    ],
                }
            }
        },
        methods:{
            ...mapActions(['setInvoiceInfo','addStockToWarehouse']),
            handleReceiveOrderCancel(){
                this.receiveOrderVisible = false
            },
            cancelPurchaseOrder(data){
                const request = {
                    status: 4,
                    id: data.id
                }
                this.$emit('orderStatus',request) 
            },
            handleTableChange(pagination){
                // this.tableLoading = true
                // console.log("pagination before change | ", this.pagination);
                const pager = { ...this.pagination };
                pager.current = pagination.current;
                this.pagination = pager;
                this.$emit("invoiceData", this.pagination)
                // this.setPaginationInfo(this.pagination)
                // this.tableLoading = false
            },
            handleSearch(selectedKeys, confirm, dataIndex) {
                confirm();
                this.searchText = selectedKeys[0];
                this.searchedColumn = dataIndex;
            },
            handleReset(clearFilters) {
                clearFilters();
                this.searchText = '';
                this.loadInvoices()
            },
            loadInvoices(){
                this.$emit("invoiceData")
            },
            onChangeIssuer(value){
                if (this.allowedPayment.includes(parseInt(value))) {
                    value === '8' ? this.paymentModel.amount = this.data.totalOrderValue : this.paymentModel.amount = '';
                    value === '8' ? this.paymentModel.reference = this.generateRandomString(8) : this.paymentModel.reference = '';
                    this.showPayemntAmount = true
                } else {
                    value === '8' ? this.paymentModel.amount = this.data.totalOrderValue : this.paymentModel.amount = '';
                    value === '8' ? this.paymentModel.reference = this.generateRandomString(8) : this.paymentModel.reference = '';
                    this.showPayemntAmount = false
                }
            },
            generateRandomString(len) {
                let randomString = '';
                let characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

                for ( let i = 0; i < len; i++ ) {
                randomString += characters.charAt(Math.floor(Math.random()*characters.length));
            }
            return randomString;
            },
            showPaymentModal(data) {
                this.data = data
                this.paymentModalVisible = true
            },
            
            showCancelInvoice(data){
                this.data = data
                this.cancelModalVisible = true
            },
            handleCancelVisibleCancel(){
                this.cancelModalVisible = false
            },
            handlePaymentVisibleCancel(){
                this.paymentModalVisible = false
            },
             recordPayment(){
                this.$refs.paymentForm.validate( async (valid) => {
                    if (valid) {
                        this.loading = true
                        const request = {
                            id: this.data.id,
                            data: {
                                orderType: parseInt(this.data.orderType) ,
                                issuer: parseInt(this.paymentModel.issuer),
                                paymentAccount: this.allowedPayment.includes(parseInt(this.paymentModel.issuer)) ? this.paymentModel.paymentAccount :  this.data.customerPhoneNumber,
                                amount: parseFloat(this.paymentModel.amount) ,
                                orderId: this.data.orderId,
                                reference: this.paymentModel.reference
                            }
                        }
                        // console.log("request | ", request)
                        const response = await this.$store.dispatch('invoices/payInvoice', request)
                        this.loading = false
                        if(response.status === 200){
                            this.paymentModalVisible = false
                             this.showSuccessAlert('Payment Made Successfully');
                             this.$refs.paymentForm.resetFields()
                        }else{
                            this.showErrorAlert(response.data.messages);
                        }
                    }else {
                        return false
                    }
                })
            },

            async cancelInvoice(){
                this.loading = true;
                const request = {
                    id: this.data.id,
                    data: {
                        status: 5
                    }
                }
                
                const response = await this.$store.dispatch('invoices/updateInvoice', request)
                this.loading = false
                if(response.status === 200){
                    this.cancelModalVisible = false;
                    this.$emit("invoiceStatus", request)
                    this.showSuccessAlert('Payment Cancelled Successfully');
                }else{
                    this.showErrorAlert(response.data.messages);
                }
            },
            
            completedOrder(data){
                const request = {
                    status: 3,
                    id: data.id
                }
                this.$emit('orderStatus',request) 
            },
            
            markAsSend(data){
                const request = {
                    status: 1,
                    id: data.id
                }
                this.$emit('orderStatus',request) 
            },
            showReceiveModal(data){
                this.data = data
                this.receiveOrderVisible = true
            },
            showMoreDetails(data){
                // console.log("data | ", data)
                this.setInvoiceInfo(JSON.stringify(data)); 
                this.$router.push({
                    name: 'invoice-details'
                    }).catch(()=>{})
            },
            showCancelActions(data){
                const allowedStatus = ['Pending']
                const result = allowedStatus.includes(data.invoiceStatusTypeLabel) ? true : false
                return result
            },
            showRecordAction(data){
                const allowedStatus = ['Pending','PartiallyPaid']
                const result = allowedStatus.includes(data.invoiceStatusTypeLabel) ? true : false
                return result
            },
            showPreview(data){
                const allowedStatus = ['Pending','PartiallyPaid','Paid','Overdue','CriticallyOverdue','Cancelled']
                const result = allowedStatus.includes(data.invoiceStatusTypeLabel) ? true : false
                return result
            },
            showDownload(data){
                const allowedStatus = ['Pending','PartiallyPaid','Paid','Overdue','CriticallyOverdue','Cancelled']
                const result = allowedStatus.includes(data.invoiceStatusTypeLabel) ? true : false
                return result
            },
            showMarkAsSendActions(data){
                const allowedStatus = ['Draft']
                const result = allowedStatus.includes(data.statusLabel) ? true : false
                return result
            },
            showInvoicesProducts(data){
                
                this.invoiceData.sellerName = data.sellerName
                this.invoiceData.sellerAddress = data.sellerAddress
                this.invoiceData.sellerCity = data.sellerCity
                this.invoiceData.sellerCountry = data.sellerCountry

                this.invoiceData.retailerName = data.customerName
                this.invoiceData.retailerAddress = data.customerAddress
                this.invoiceData.retailerCity = data.customerCity
                this.invoiceData.retailerCountry = data.customerCountry
                this.invoiceData.phoneNumber = data.customerPhoneNumber

                this.invoiceData.terms = data.terms
              
                this.invoiceData.dueDate = moment(data.dueDate).format("DD-MM-YYYY")
                this.invoiceData.cowtribeDate = moment(data.createdAt).format("DD-MM-YYYY")
                this.invoiceData.invoiceId = data.id
                this.invoiceData.reference = null
                this.invoiceData.products = data.invoiceLines.map(product => ({
                    id: product.id,
                    productName: product.productName,
                    quantity: product.quantity,
                    unitPrice: product.price,
                    lineTotal: parseInt(product.quantity) * parseFloat(product.price)
                }))

                this.invoiceData.total = this.getProductsTotalAmount(this.invoiceData.products)
                this.$refs.invoiceRef.showInvoiceForm(this.invoiceData);
            },
            downloadInvoice(data){
                this.invoiceData.sellerName = data.sellerName
                this.invoiceData.sellerAddress = data.sellerAddress
                this.invoiceData.sellerCity = data.sellerCity
                this.invoiceData.sellerCountry = data.sellerCountry

                this.invoiceData.retailerName = data.customerName
                this.invoiceData.retailerAddress = data.customerAddress
                this.invoiceData.retailerCity = data.customerCity
                this.invoiceData.retailerCountry = data.customerCountry
                this.invoiceData.phoneNumber = data.customerPhoneNumber

                this.invoiceData.terms = data.terms
              
                this.invoiceData.dueDate = moment(data.dueDate).format("DD-MM-YYYY")
                this.invoiceData.cowtribeDate = moment(data.createdAt).format("DD-MM-YYYY")
                this.invoiceData.invoiceId = data.id
                this.invoiceData.reference = null
                this.invoiceData.products = data.invoiceLines.map(product => ({
                    id: product.id,
                    productName: product.productName,
                    quantity: product.quantity,
                    unitPrice: product.price,
                    lineTotal: parseInt(product.quantity) * parseFloat(product.price)
                }))

                this.invoiceData.total = this.getProductsTotalAmount(this.invoiceData.products)
                this.$refs.invoiceDownloadRef.downloadInvoice(this.invoiceData);
            },

            getProductsTotalAmount(products){
                // console.log("in tableData |", this.tableData)
                const itemAmount = products.map(item => {
                    if(item.unitPrice && item.quantity){
                        return parseFloat(item.unitPrice)  * item.quantity
                    }else{
                        return 0.00
                    }
                })
                // console.log("in each itemAmount |", itemAmount)
                const totalAmt = itemAmount.reduce((acc, item) => acc + item, 0);
                // console.log("in computed totalAmt |", totalAmt)
                return parseFloat(totalAmt)

            },
            async handleAddInventoryTransfer(data){
                this.loading = true;
                const response = await this.addStockToWarehouse(data);
                this.loading = false;
                if (response.status === 200) {
                    this.receiveOrderVisible = false
                    this.showSuccessAlert("Purchase Order Received Successfully");
                    this.$emit('orderData', true)  
                } else {
                    // // console.log("Error | ", response);
                    this.showErrorAlert(response.data.messages);
                }  
                 
            },
        },
        computed:{
            disableCreditInput() {
                return this.paymentModel.issuer === '8' ? true : false;
            }
        },
        watch: { 
            purchaseOrdersData:{
                immediate: true, 
                handler (newValues) {
                  this.tableInvoices = newValues.map((item) => ({ ...item, paymentMethod: item.paymentMethod ? item.paymentMethod : 'N/A', balance: item.balance ? item.balance : 'N/A'  }));
                }
            },
            paginateData:{
                immediate: true, 
                handler (newValues) {
                    this.pagination.total = newValues.totalRecords
                    this.pagination.current = newValues.current
                }
            }    
        }
    }
</script>

<style  scoped>
.ant-table-wrapper {
  zoom: 1;
  background: #fff;
  margin-bottom: 30px;
}
.customerTable >>> .ant-table-thead th {
  background: #c7c7c763;
  height: 63px;
}

.customerTable >>> .ant-pagination-item-active {
  background: #418a49;
  border-color: #418a49;
}

.customerTable >>> .ant-pagination-item-active a {
  color: #fff;
}
.customerTable >>> .ant-table-pagination {
  float: none;
  margin: 16px 0;
  display: flex;
  justify-content: center;
}

.orderTable >>> .ant-table-thead th {
  background: #c7c7c763;
  height: 63px;
}

.orderTable >>> .ant-pagination-item-active {
  background: #418a49;
  border-color: #418a49;
}

.orderTable >>> .ant-pagination-item-active a {
  color: #fff;
}
.orderTable >>> .ant-table-pagination {
  float: none;
  margin: 16px 0;
  display: flex;
  justify-content: center;
}

.tableStyle >>> .ant-table-tbody > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td {
    background: #26A246;
    color: #fff;
  
}


.tableStyle >>> .ant-table-thead th {
    background: #fff;
    height: 63px;
}

.tableStyle >>> .ant-table-header  {
    background: #fff !important;
}
</style>